import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { selectBlogPostsListItems } from "../../../../../../redux/blog-posts/selector";
import { blogPosts } from "../../../../../../redux/blog-posts/action";
import Table from "../../../../../../common/components/table";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../../components/PageLoader";

const ManagementBlogPosts = () => {
  const dispatch = useAppDispatch()

  const navigate = useNavigate()

  const [pageData, setPageData] = useState(1)
  const blogPostItems = useSelector(selectBlogPostsListItems)
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Title', headerName: 'Title' },
      { field: 'Caption', headerName: 'Caption' },
      { field: 'BlogShowStartDateUtc', headerName: 'StartDate /Time', isDateValueFormat: true },
      { field: 'BlogShowEndDateUtc', headerName: 'EndDate /Time', isDateValueFormat: true },
      { field: 'MetaKeywords', headerName: 'MetaKeywords' },
      { field: 'MetaDescription', headerName: 'MetaDescription' },
      { field: 'MetaTitle', headerName: 'MetaTitle' },
      { field: 'CreatedDateUTC', headerName: 'CreatedDate /Time', isDateValueFormat: true },
      { field: 'ModifiedDateUTC', headerName: 'ModifiedDate /Time', isDateValueFormat: true },
      { field: 'IsCommentsAllowed', headerName: 'IsCommentsAllowed', cellRenderer: 'yesNoRenderer' },
      { field: 'IsLimitedToStores', headerName: 'IsLimitedToStores', cellRenderer: 'yesNoRenderer' }

    ]);
  }

  const fetchBlogPost = () => {
    dispatch(blogPosts.list({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/blog/blog-posts/list`, entity: 'blogPosts', jsonData: {

        "PageNumber": pageData,
        "PageSize": 10,
        "SortField": "Id",
        "SortOrder": "desc",


      }
    }))
  }
  const handleEdit = (data: any) => {
    navigate(`${data?.Id}`)
  }
  const handleAdd = () => {
    navigate(`${0}`)
  }
  const additionButtons: any = [
    {
      name: 'Add BlogPosts',
      callback: () => handleAdd(),
    }
  ];
  useEffect(() => {
    createColumnDefs()
    fetchBlogPost()
  }, [pageData])
  const handleDelete = (data: any) => {
    dispatch(blogPosts.delete({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/blog/blog-posts/delete`,
      entity: 'blogPosts',
      jsonData: {
        Records: [
          {

            Id: data?.Id
          }

        ]
      }
    })).then(() => {
      dispatch(blogPosts.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/blog/blog-posts/list`, entity: 'blogPosts', jsonData: {

          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",


        }
      }))
    });
  }
  return (
    <>
      {blogPostItems?.isLoading ? <PageLoader /> :
        <Table columnData={columnDefs} rowData={blogPostItems?.result?.items} setPageData={setPageData}
          paginationData={blogPostItems?.result?.pagination} onEdit={handleEdit} additionButtons={additionButtons} onDelete={handleDelete} headingName="Blog Posts" />

      }
    </>
  );
};

export default ManagementBlogPosts;


